export default __webpack_public_path__ + "static/hello-5260c80a8bcf21c7d01367f2f6a2584e.jpg";